import { CustomErrorToastHTML } from '@/@straico-ui/commons/CustomToasts';
import toast from 'react-hot-toast';
import { containsHTML } from './htmlSanitizer';

/**
 * Smart toast that automatically detects HTML content and uses appropriate rendering
 * @param {string} message - Message to display (can contain HTML)
 * @param {object} options - Toast options
 */
export const smartToastError = (message, options = {}) => {
  const isHTML = containsHTML(message);

  if (isHTML) {
    // Use custom HTML toast for HTML content
    return toast.custom(
      (t) => <CustomErrorToastHTML id={t.id} message={message} />,
      {
        duration: 20000,
        position: 'top-right',
        ...options,
      }
    );
  } else {
    // Use regular toast for plain text
    return toast.error(message, {
      duration: 8000,
      position: 'top-right',
      ...options,
    });
  }
};

/**
 * Smart toast with custom duration configuration
 * @param {string} message - Message to display
 * @param {number} duration - Duration in milliseconds
 * @param {object} options - Additional toast options
 */
export const smartToastErrorWithDuration = (
  message,
  duration,
  options = {}
) => {
  return smartToastError(message, {
    duration,
    ...options,
  });
};

/**
 * Smart toast for critical errors (never auto-dismiss)
 * @param {string} message - Message to display
 * @param {object} options - Additional toast options
 */
export const smartToastCriticalError = (message, options = {}) => {
  return smartToastError(message, {
    duration: 0, // Never auto-dismiss
    ...options,
  });
};
